import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap, takeUntil } from 'rxjs/operators'

import { getCampaignSuccess } from '../steps/actions'
import { validateMessageStep } from '../steps/MessageStep/actions'
import { validateStepFields } from '../steps/SetupStep/actions'

import { getCampaignError, getCampaignSuccess as getEditCampaignSuccess } from './actions'
import { GET_CAMPAIGN_ASYNC, INIT_EDIT_MODE } from './constants'

const getCampaignEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(INIT_EDIT_MODE),
    mergeMap((action) =>
      api.wizardCampaign
        .getCampaign(state$.value.partnerOptions.selectedCompany?.value, action.payload.campaignId)
        .pipe(
          mergeMap((response) =>
            of(
              getEditCampaignSuccess(response.flow_type),
              getCampaignSuccess(response),
              validateStepFields(),
              validateMessageStep()
            )
          ),
          catchError((error) => of(epicsErrorHandler(getCampaignError, error, [400]))),
          takeUntil(action$.pipe(ofType(GET_CAMPAIGN_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getCampaignEpic)
